import { render, staticRenderFns } from "./StorageDialog.vue?vue&type=template&id=f7197c68&"
import script from "./StorageDialog.vue?vue&type=script&lang=ts&"
export * from "./StorageDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports